// import React from "react";

interface IShareZaloProps {
  url: string;
}

export const ShareZalo = ({ url }: IShareZaloProps) => {
  return null;
  // const zaloSdkName = "ZaloSocialSDK"

  // React.useEffect(() => {
  //     initScript();
  // }, [url])

  // const initScript = () => {
  //     const id = 'zalo-skd';
  //     const scriptElement = document.getElementById(id)
  //     if (scriptElement) {
  //         initZalo()
  //         return;
  //     }

  //     let js = document.createElement('script');
  //     js.id = id;
  //     js.async = true;
  //     js.src = 'https://sp.zalo.me/plugins/sdk.js';
  //     js.onload = () => {
  //         initZalo()
  //     }

  //     let header = getHeader();

  //     if (header) {
  //         header.appendChild(js)
  //     } else {
  //         setTimeout(() => {
  //             header = getHeader();
  //             if (header) {
  //                 header.appendChild(js);
  //             }
  //         }, 500)
  //     }
  // };

  // const initZalo = () => {
  //     let _windows = Object.assign(window)

  //     if (_windows[zaloSdkName]) {
  //         _windows[zaloSdkName].init()
  //     }
  // }

  // const getHeader = () => {
  //     let collection = document.getElementsByTagName('head')
  //     if (collection && collection.length > 0) {
  //         return collection[0];
  //     }
  //     return null
  // }

  // return <div
  //     className="btn-share-item-wrapper"
  //     dangerouslySetInnerHTML={{
  //         __html: `<div
  //               class="zalo-share-button btn-zalo-share-wrap"
  //               data-href=${url}
  //               data-oaid="579745863508352884"
  //               data-layout="4"
  //               data-color="blue"
  //               data-customize="false"></div>`,
  //     }}></div>
};
